import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import scui from './scui'
import i18n from './locales'
import router from './router'
import store from './store'
import App from './App.vue'
import DataVVue3 from '@kjgl77/datav-vue3'

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(DataVVue3)
app.use(i18n);
app.use(scui);

//挂载app
app.mount('#app');
